import { SHOP_NAV } from "@/lib/nav";

/**
 * Every item in the header, as a button a shop can point its billboard at. The store owner picks
 * one at /account/store and that's the button their sign carries on the directory homepage.
 */
export const MENU_ITEMS = [
    { key: "store", label: "Open the shop", to: (s) => `/stores/${s}` },
    ...SHOP_NAV.map((n) => ({ key: n.key, label: n.label, to: (s) => (["/shirts", "/signs"].includes(n.to) ? `${n.to}?store=${s}` : n.to) })),
    { key: "dtf", label: "DTF Gang Sheet", to: (s) => `/shirts/dtf?store=${s}` },
    { key: "artwork", label: "Artwork Request", to: () => "/artwork-request" },
    { key: "website", label: "Need A Website", to: () => "/website-design" },
    // Buttons picked before the menu changed still resolve.
    { key: "same_day", label: "Same Day Shirts", to: (s) => `/shirts?ready=same_day&store=${s}`, legacy: true },
    { key: "standard", label: "Shirts", to: (s) => `/shirts?store=${s}`, legacy: true },
    { key: "white", label: "Same Day Shirts", to: (s) => `/shirts?ready=same_day&store=${s}`, legacy: true },
    { key: "apparel", label: "Shirts", to: (s) => `/shirts?store=${s}`, legacy: true },
];

export const MENU_MAP = Object.fromEntries(MENU_ITEMS.map((m) => [m.key, m]));

/** The button a store's billboard shows: their pick, else their own front door. */
export const billboardButton = (store, billboard) => {
    const pick = MENU_MAP[store?.billboard_button];
    if (pick) return { label: pick.key === "store" ? `Shop ${store.name}` : pick.label, to: pick.to(store.slug) };
    return {
        label: billboard?.cta_label || `Shop ${store?.name || "the store"}`,
        to: billboard?.cta_url || `/stores/${store?.slug}`,
    };
};
